export function Cond(props: { show: boolean, children: React.ReactNode }): (JSX.Element | null) {
    if (!props.show) {
        return null
    }
    return <>{props.children}</>
}
